import { action, createRequestTypes } from '../base';

export const unicommerceIntegrationActionTypes = {
  GET_UNICOMMERCE_CONNECTIONS: createRequestTypes('GET_UNICOMMERCE_CONNECTIONS'),
  CONNECT_TO_UNICOMMERCE: createRequestTypes('CONNECT_TO_UNICOMMERCE'),
  CONNECT_TENANT_TO_LOCATION_UNICOMMERCE: createRequestTypes('CONNECT_TENANT_TO_LOCATION_UNICOMMERCE'),
  VERIFY_LOCATION: createRequestTypes('VERIFY_LOCATION'),
  SYNC_PRODUCT: createRequestTypes('SYNC_PRODUCT'),
  SYNC_SO: createRequestTypes('SYNC_SO'),
  ADJUST_UNICOMMERECE_INVENTORY: createRequestTypes('ADJUST_UNICOMMERECE_INVENTORY'),
  UPDATE_UNICOMMERCE_CONFIGURATION: createRequestTypes('UPDATE_UNICOMMERCE_CONFIGURATION'),
  SCHEDULE_UNICOMMERCE_SYNC: createRequestTypes('SCHEDULE_UNICOMMERCE_SYNC'),
  DELETE_UNICOMMERCE_SYNC: createRequestTypes('DELETE_UNICOMMERCE_SYNC'),
};

/**
 * @param payload
 * @param linkedDaData
 * @param connectToUnicommerceSuccess
 * @param callback
 * @param orgId
 */
class UnicommerceIntegrationActions {
  /**
   *
   * @param {*} orgId
   * @param {*} callback
   * @returns
   */
   getUnicommerceConnections = (orgId, callback) => action(unicommerceIntegrationActionTypes.GET_UNICOMMERCE_CONNECTIONS.REQUEST, {
     orgId, callback,
   })

    /**
     *
     * @param {*} getUnicommerceConnectionsLoading
     * @return
     */
    getUnicommerceConnectionsLoading = (getUnicommerceConnectionsLoading) => action(unicommerceIntegrationActionTypes.GET_UNICOMMERCE_CONNECTIONS.LOADING, {
      getUnicommerceConnectionsLoading,
    })

     /**
      * @return
      * @param linkedDaData
      */
     getUnicommerceConnectionsSuccess = (unicommerceConnections) => action(unicommerceIntegrationActionTypes.GET_UNICOMMERCE_CONNECTIONS.SUCCESS, {
       unicommerceConnections,
     })

     /**
        * @return
        * @param orgId
        * @param callback
        */
     connectToUnicommerce = (payload, callback) => action(unicommerceIntegrationActionTypes.CONNECT_TO_UNICOMMERCE.REQUEST, {
       payload, callback,
     })

      /**
       * @return
       * @param connectToUnicommerceLoading
       */
      connectToUnicommerceLoading = (connectToUnicommerceLoading) => action(unicommerceIntegrationActionTypes.CONNECT_TO_UNICOMMERCE.LOADING, {
        connectToUnicommerceLoading,
      })

      /**
       *
       * @param {*} connectedToUnicommerce
       * @returns
       */
      connectToUnicommerceSuccess = (connectedToUnicommerce) => action(unicommerceIntegrationActionTypes.CONNECT_TO_UNICOMMERCE.SUCCESS, {
        connectedToUnicommerce,
      })

      /**
       * @param {*} payload
       * @param callback
       * @return
       */
       connectTenantToLocation = (payload, callback) => action(unicommerceIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION_UNICOMMERCE.REQUEST, {
         payload, callback,
       })

      /**
       * @return
       * @param connectTenantToLocationLoading
       */
      connectTenantToLocationLoading = (connectTenantToLocationLoading) => action(unicommerceIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION_UNICOMMERCE.LOADING, {
        connectTenantToLocationLoading,
      })

      /**
       *
       * @param {*} orgId
       * @param {*} callback
       * @returns
       */
      verifyLocation = (orgId, facilityCode, callback) => action(unicommerceIntegrationActionTypes.VERIFY_LOCATION.REQUEST, {
        orgId, facilityCode, callback,
      })

      /**
        *
        * @param {*} verifyLocationLoading
        * @return
        */
      verifyLocationLoading = (verifyLocationLoading) => action(unicommerceIntegrationActionTypes.VERIFY_LOCATION.LOADING, {
        verifyLocationLoading,
      })

      /**
         * @return
         * @param linkedDaData
         */
      verifyLocationLoadingSuccess = (isLocationVerified) => action(unicommerceIntegrationActionTypes.VERIFY_LOCATION.SUCCESS, {
        isLocationVerified,
      })

      /**
       *
       * @param {*} orgId
       * @param {*} callback
       * @returns
       */
      syncProducts = (payload, callback) => action(unicommerceIntegrationActionTypes.SYNC_PRODUCT.REQUEST, {
        payload, callback,
      })

      /**
       *
       * @param {*} syncProductsLoading
       * @returns
       */
      syncProductsLoading = (syncProductsLoading) => action(unicommerceIntegrationActionTypes.SYNC_PRODUCT.LOADING, {
        syncProductsLoading,
      })

      /**
       *
       * @param {*} orgId
       * @param {*} callback
       * @returns
       */
      syncSO = (payload, callback) => action(unicommerceIntegrationActionTypes.SYNC_SO.REQUEST, {
        payload, callback,
      })

      /**
       *
       * @param {*} syncSOLoading
       * @returns
       */
      syncSOLoading = (syncSOLoading) => action(unicommerceIntegrationActionTypes.SYNC_SO.LOADING, {
        syncSOLoading,
      })

      /**
       *
       * @param {*} orgId
       * @param {*} callback
       * @returns
       */
        adjustUnicommerceInventory = (payload, callback) => action(unicommerceIntegrationActionTypes.ADJUST_UNICOMMERECE_INVENTORY.REQUEST, {
          payload, callback,
        })

      /**
       *
       * @param {*} adjustUnicommerceInventoryLoading
       * @returns
       */
      adjustUnicommerceInventoryLoading = (adjustUnicommerceInventoryLoading) => action(unicommerceIntegrationActionTypes.ADJUST_UNICOMMERECE_INVENTORY.LOADING, {
        adjustUnicommerceInventoryLoading,
      })

      /**
       *
       * @param {*} orgId
       * @param {*} callback
       * @returns
       */
      updateUnicommerceConfiguration = (payload, callback) => action(unicommerceIntegrationActionTypes.UPDATE_UNICOMMERCE_CONFIGURATION.REQUEST, {
        payload, callback,
      })

    /**
     *
     * @param {*} updateUnicommerceConfigurationLoading
     * @returns
     */
    updateUnicommerceConfigurationLoading = (updateUnicommerceConfigurationLoading) => action(unicommerceIntegrationActionTypes.UPDATE_UNICOMMERCE_CONFIGURATION.LOADING, {
      updateUnicommerceConfigurationLoading,
    })

    scheduleUcSync = (payload, callback) => action(unicommerceIntegrationActionTypes.SCHEDULE_UNICOMMERCE_SYNC.REQUEST, {
      payload, callback,
    })

    scheduleUcSyncLoading = (scheduleUcSyncLoading) => action(unicommerceIntegrationActionTypes.SCHEDULE_UNICOMMERCE_SYNC.LOADING, {
      scheduleUcSyncLoading,
    })

    deleteUcSync = (payload, callback) => action(unicommerceIntegrationActionTypes.DELETE_UNICOMMERCE_SYNC.REQUEST, {
      payload, callback,
    })

    deleteUcSyncLoading = (deleteUcSyncLoading) => action(unicommerceIntegrationActionTypes.DELETE_UNICOMMERCE_SYNC.LOADING, {
      deleteUcSyncLoading,
    })

}

export default new UnicommerceIntegrationActions();
